module.exports = __webpack_public_path__ + "static/media/grains_5.328329d5.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/grains/grains_5.csv
// module id = 733
// module chunks = 0